// extracted by mini-css-extract-plugin
export default {"message":"Message_message__UdveK","primary":"Message_primary__lysmd","secondary":"Message_secondary__W1k5h"};